import { render, staticRenderFns } from "./AddAnnexe.vue?vue&type=template&id=fca5e64c&scoped=true"
import script from "./AddAnnexe.vue?vue&type=script&lang=js"
export * from "./AddAnnexe.vue?vue&type=script&lang=js"
import style0 from "./AddAnnexe.vue?vue&type=style&index=0&id=fca5e64c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca5e64c",
  null
  
)

export default component.exports